import React from 'react';
import calanderImage from '../../../assets/img/event-details-imgs/event-calendar.svg';
import eventCoverimg from '../../../assets/img/event-details-imgs/event-coverimg.png';
const EventTopBanner = () => {
    return (
        <div className="col position-relative">
            <div className="position-absolute h-100 w-100" style={{borderRadius: "40px", background: "linear-gradient(#00000000, #000000 99%)"}}></div>
            <div className="row gap-2 gap-lg-3 position-absolute" style={{left: "5%",bottom: "5%"}}>
                <div className="col-12">
                    <div className="rounded-pill py-2 px-3 d-inline-block" style={{backgroundColor: "#FFFFFF18"}}>
                        <div className="d-flex justify-content-center align-items-center">
                            <img className="me-3" src={calanderImage} alt='' /><span className="ed_dm">Mon, Nov 29&nbsp;</span><span className="bd_username">on 11:00 pm</span></div>
                    </div>
                </div>
                <div className="col-12"><span className="bd_username" style={{color: "#40EEFE", fontWeight: "500"}}>Online Event&nbsp;·&nbsp;Monthly</span></div>
                <div className="col-12">
                    <h1 className="ed_h2 mb-0">In pulvinar libero eu puru vehicula, <br />et luctus...</h1>
                </div>
                <div className="col-12">
                    <p className="db_para mb-0">Morbi venenatis et nisi finibus egestas. Morbi arcu metus, dictum <br />sit amet consectetur ac, iaculis ac nisi.</p>
                </div>
            </div><img className="w-100" src={eventCoverimg} style={{borderRadius: "40px"}} alt='' /> 
        </div>
    );
};

export default EventTopBanner;